interface AuthLoadingScreenProps {
  message?: string;
}

export function AuthLoadingScreen({
  message = "Sitzung wird geprueft...",
}: AuthLoadingScreenProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm px-6 py-5 text-center">
        <div className="mx-auto mb-3 h-10 w-10 rounded-full border-2 border-gray-200 border-t-black animate-spin" />
        <p className="text-sm text-gray-600">{message}</p>
      </div>
    </div>
  );
}
